const React = require('react');
const ReactRedux = require('react-redux');
const ReactRouter = require('react-router');

const CurrentBuildStatus = require('./CurrentBuildStatus.jsx');
const EnvironmentDetails = require('./EnvironmentDetails.jsx');
const UpcomingDeployments = require('./UpcomingDeployments.jsx');
const DeployHistory = require('./DeployHistory.jsx');

const App = function App(props) {
	let output = (
		<div>
			<CurrentBuildStatus />
			<div className="row">
				<div className="col-md-9">
					<EnvironmentDetails />
				</div>
				<div className="col-md-3 text-right">
					<ReactRouter.Link className="btn btn-primary" to="/deployment/new">
						New deployment
					</ReactRouter.Link>
				</div>
			</div>
			<UpcomingDeployments />
			<DeployHistory />
			{props.children}
		</div>
	);
	if (props.environment.is_ready === false) {
		output = (
			<div className="alert alert-warning">
				<span dangerouslySetInnerHTML={{__html: props.environment.not_ready_message}}></span>
			</div>
		);
	}

	return output;
};

const mapStateToProps = function(state) {
	return {
		environment: state.environment
	};
};

module.exports = ReactRedux.connect(mapStateToProps)(App);
